import React, { useState } from "react";
import {
  FaMusic,
  FaUtensils,
  FaLeaf,
  FaPuzzlePiece,
  FaPalette,
  FaLandmark,
  FaHandsHelping,
  FaPaintBrush,
  FaTheaterMasks,
  FaMicrophone,
  FaFemale,
  FaTshirt,
  FaGuitar,
  FaBroadcastTower,
  FaChild,
} from "react-icons/fa";

import "../../css/CoCurricular.css";
import SchoolHero from "../SchoolLevels/SchoolHero";

const CLUBS = [
  {
    icon: <FaMusic />,
    title: "Jhankar Club",
    desc: "Develop rhythm, vocals and confidence through music.",
  },
  {
    icon: <FaUtensils />,
    title: "Cooking Without Fire",
    desc: "Learn healthy recipes, creativity and teamwork.",
  },
  {
    icon: <FaLeaf />,
    title: "Sustainable Development Goals",
    desc: "Promote environmental awareness and responsible citizenship.",
  },
  {
    icon: <FaPuzzlePiece />,
    title: "Practical Life Skills",
    desc: "Build essential everyday skills for independent living.",
  },
  {
    icon: <FaPalette />,
    title: "Picasso Club",
    desc: "Creative drawing and painting for Grades 1 & 2.",
  },
  {
    icon: <FaLandmark />,
    title: "Heritage Club",
    desc: "Explore history, culture and national heritage.",
  },
  {
    icon: <FaHandsHelping />,
    title: "Community Connect Club",
    desc: "Participate in social service and community projects.",
  },
  {
    icon: <FaUtensils />,
    title: "Culinary Club",
    desc: "Discover cooking techniques and nutrition.",
  },
  {
    icon: <FaFemale />,
    title: "Classical Dance Club",
    desc: "Learn traditional dance with discipline and grace.",
  },
  {
    icon: <FaPaintBrush />,
    title: "Art Club",
    desc: "Express creativity through visual arts.",
  },
  {
    icon: <FaChild />,
    title: "Craft Club",
    desc: "Create innovative crafts using different materials.",
  },
  {
    icon: <FaTheaterMasks />,
    title: "Theatre Club",
    desc: "Improve acting, expression and stage confidence.",
  },
  {
    icon: <FaMicrophone />,
    title: "Vocal Club",
    desc: "Enhance singing skills through guided practice.",
  },
  {
    icon: <FaTshirt />,
    title: "Fashion Designing Club",
    desc: "Explore fashion, design and creativity.",
  },
  {
    icon: <FaGuitar />,
    title: "Instrumental Music Club",
    desc: "Learn different musical instruments with expert guidance.",
  },
  {
    icon: <FaPalette />,
    title: "Art Integration",
    desc: "Creative interdisciplinary learning for Grades 9 & 10.",
  },
  {
    icon: <FaFemale />,
    title: "Dance",
    desc: "Develop coordination, fitness and confidence.",
  },
  {
    icon: <FaMusic />,
    title: "Music",
    desc: "Discover melodies, rhythm and performance skills.",
  },
  {
    icon: <FaPaintBrush />,
    title: "Art",
    desc: "Explore imagination through drawing and painting.",
  },
  {
    icon: <FaBroadcastTower />,
    title: "Radio Jockey",
    desc: "Improve communication and presentation skills.",
  },
];

const FAQ_ITEMS = [
  {
    q: "Why are co-curricular activities important?",
    a: "Co-curricular activities help students develop creativity, confidence, teamwork, leadership, communication and problem-solving skills while supporting their overall personality development.",
  },
  {
    q: "Can every student participate in clubs?",
    a: "Yes. Every student is encouraged to join one or more clubs according to their interests and talents throughout the academic year.",
  },
  {
    q: "How do these activities benefit students academically?",
    a: "They improve concentration, confidence, creativity and social skills, which positively influence classroom learning and overall academic performance.",
  },
];

export default function CoCurricular() {
  const [openFaq, setOpenFaq] = useState(0);
    return (
    <main className="cca-page">
      <SchoolHero
        title="Co-Curricular Activities"
        subtitle="World-Class Infrastructure"
         image="./images/high.jpg"
      />

      <section className="cca-hero">
        <div className="cca-container">
          <span className="cca-tag">Beyond Academics</span>

          <h1>Co-Curricular Activities</h1>

          <p className="cca-lead">
            At Sahara Public School, learning extends beyond the classroom.
            Every child is encouraged to participate in meaningful activities
            that develop creativity, confidence, leadership, teamwork and
            lifelong skills.
          </p>
        </div>
      </section>

      <section className="cca-intro-section">
        <div className="cca-container">
          <div className="cca-intro">

            <div className="cca-content">

              <span className="cca-tag">
                Holistic Development
              </span>

              <h2>Building Talent Beyond Textbooks</h2>

              <p>
                Co-curricular activities play a vital role in nurturing the
                overall development of every learner. These experiences allow
                students to discover their interests while building confidence,
                communication skills and creativity.
              </p>

              <p>
                Every learner is encouraged to participate in activities that
                complement classroom learning and help them become responsible,
                innovative and compassionate individuals.
              </p>

              <p>
                Through competitions, performances, collaborative projects and
                leadership opportunities, students gain valuable life skills
                that prepare them for future success.
              </p>

            </div>

            <div className="cca-image-card">

              <div className="cca-circle">
                <FaPalette />
              </div>

            </div>

          </div>
        </div>
      </section>

      <section className="cca-house">

        <div className="cca-container">

          <div className="cca-house-box">

            <span className="cca-tag">
              House System
            </span>

            <h2>Growing Together Through Team Spirit</h2>

            <p>
              Every student becomes a member of one of our school houses,
              encouraging teamwork, leadership, discipline and healthy
              competition throughout the academic year.
            </p>

          </div>

        </div>

      </section>

      <section className="cca-why-section">

        <div className="cca-container">

          <div className="cca-why">

            <span className="cca-tag">
              Why It Matters
            </span>

            <h2>Learning Beyond The Classroom</h2>

            <p>
              Co-curricular learning enables students to build communication,
              collaboration, creativity and leadership skills while discovering
              their individual strengths.
            </p>

            <p>
              Exposure to real-world activities develops discipline,
              confidence, emotional intelligence and problem-solving abilities,
              helping students become future-ready citizens.
            </p>

          </div>

        </div>

      </section>
            <section className="cca-clubs">

        <div className="cca-container">

          <div className="cca-section-title">

            <span className="cca-tag">
              Student Clubs
            </span>

            <h2>Our Clubs & Programs</h2>

            <p className="cca-lead">
              Students can explore a wide range of clubs that nurture
              creativity, innovation, teamwork and leadership while making
              learning enjoyable and meaningful.
            </p>

          </div>

          <div className="cca-grid">

            {CLUBS.map((club) => (

              <article
                className="cca-card"
                key={club.title}
              >

                <div className="cca-icon">
                  {club.icon}
                </div>

                <h3>{club.title}</h3>

                <p>{club.desc}</p>

              </article>

            ))}

          </div>

        </div>

      </section>

      <section className="cca-feature-section">

        <div className="cca-container">

          <div className="cca-feature-box">

            <div className="cca-feature-icon">
              <FaMusic />
            </div>

            <div className="cca-feature-content">

              <span className="cca-tag">
                Featured Program
              </span>

              <h2>School of Music</h2>

              <p>
                Our School of Music provides students with expert guidance in
                vocal and instrumental music, helping them build confidence,
                creativity and a lifelong appreciation for performing arts.
              </p>

            </div>

          </div>

        </div>

      </section>

      <section className="cca-faq-section">

        <div className="cca-container">

          <div className="cca-section-title">

            <span className="cca-tag">
              Frequently Asked Questions
            </span>

            <h2>Have Questions?</h2>

          </div>

          <div className="cca-faq">

            {FAQ_ITEMS.map((item, index) => {

              const isOpen = openFaq === index;

              return (

                <div
                  key={item.q}
                  className={`faq-item ${isOpen ? "active" : ""}`}
                >

                  <button
                    type="button"
                    className="faq-question"
                    onClick={() =>
                      setOpenFaq(isOpen ? -1 : index)
                    }
                  >

                    <span>{item.q}</span>

                    <span className="faq-toggle">
                      {isOpen ? "−" : "+"}
                    </span>

                  </button>

                  {isOpen && (

                    <div className="faq-answer">

                      <p>{item.a}</p>

                    </div>

                  )}

                </div>

              );

            })}

          </div>

        </div>

      </section>

    </main>
  );
}